export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <span className="text-xs font-semibold text-primary-600 uppercase tracking-wider">关于芭乐</span>
          <h2 className="mt-2 text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            关于芭乐
          </h2>
          <div className="mt-8 text-sm md:text-base text-foreground-600 leading-relaxed space-y-4">
            <p>
              芭乐视频是一个专注于聚合红桃视频、樱花视频、糖豆视频等特色视频平台的综合性内容导航站。我们不生产内容，而是通过智能聚合技术，将各大平台的热门剧集、电影、综艺等优质资源集中呈现，让您在一个页面就能轻松发现全网的精彩视频内容。
            </p>
            <p>
              平台每日追踪各合作平台的更新情况，实时同步最新的电视剧全集和电影资源。无论是正在热播的国产剧、口碑炸裂的院线大片，还是海外热门综艺和动漫番剧，芭乐视频都能帮您快速找到并一键跳转观看，享受高清流畅不缓冲的极致体验。
            </p>
            <p>
              我们坚持免费、开放、便捷的理念，聚合而不干涉，推荐而不收费。芭乐视频致力于成为中文互联网上最值得信赖的特色视频平台推荐入口，让每位观众都能找到自己喜爱的内容。
            </p>
          </div>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-8 md:gap-14">
            <div className="text-center">
              <p className="text-3xl md:text-4xl font-heading font-bold text-primary-600">6+</p>
              <p className="mt-1 text-xs text-foreground-500">特色平台聚合</p>
            </div>
            <div className="text-center">
              <p className="text-3xl md:text-4xl font-heading font-bold text-accent-600">200+</p>
              <p className="mt-1 text-xs text-foreground-500">每日资源更新</p>
            </div>
            <div className="text-center">
              <p className="text-3xl md:text-4xl font-heading font-bold text-secondary-600">99.9%</p>
              <p className="mt-1 text-xs text-foreground-500">在线播放成功率</p>
            </div>
            <div className="text-center">
              <p className="text-3xl md:text-4xl font-heading font-bold text-primary-600">∞</p>
              <p className="mt-1 text-xs text-foreground-500">完全免费使用</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}